import { RootState } from '@/models/root-state.model';

export const selectIsDrawerOpen = (state: RootState): boolean => state.drawer.drawerIsOpen;
